import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import type EstimateValues from "../../types/params"

const getNumberOfMinPattern = ({ minPattern }: Pick<EstimateValues, "minPattern">) => {
  switch (minPattern) {
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.030mm"].value:
      return 0.03
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.050mm"].value:
      return 0.05
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.060mm"].value:
      return 0.06
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.075mm"].value:
      return 0.075
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.10mm"].value:
      return 0.1
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.127mm"].value:
      return 0.127
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.15mm"].value:
      return 0.15
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.20mm"].value:
      return 0.2
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.25mm"].value:
      return 0.25
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.30mm"].value:
      return 0.3
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.35mm"].value:
      return 0.35
    case ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.40mm"].value:
      return 0.4
    default:
      throw new Error("")
  }
}

export default getNumberOfMinPattern
